import { render, staticRenderFns } from "./AnalyticsSummary.vue?vue&type=template&id=531d1442&scoped=true"
import script from "./AnalyticsSummary.vue?vue&type=script&lang=js"
export * from "./AnalyticsSummary.vue?vue&type=script&lang=js"
import style0 from "./AnalyticsSummary.vue?vue&type=style&index=0&id=531d1442&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "531d1442",
  null
  
)

export default component.exports